import { CareerCapability, ICareerJourney } from './transform';

export type CareerAccess = 'open' | 'locked' | 'preview' | 'unknown';

/**
 * Открыта ли возможность этому зрителю (ТЗ 0069).
 *
 * 🔴 Ответ приходит С СЕРВЕРА (`myCareerJourney.locked`), а не выводится здесь
 * из роли и членства. Вторая копия правила доступа разъезжается с первой в
 * первый же месяц, и разъезд этот молчаливый: экран покажет кнопку, которую
 * сервер откажет, и виноватым будет выглядеть человек.
 *
 * 🔴 Fail-closed. Пока маршрут не приехал (первая загрузка, старый бэкенд,
 * сеть) — `unknown`, и раздел ведёт себя как закрытый. Интерфейс, который на
 * ошибке распахивает всё, один раз покажет участнику чужую пустоту, и это
 * прочитается как поломка продукта.
 */
export const careerAccess = (
  journey: ICareerJourney | null,
  capability: CareerCapability,
): CareerAccess => {
  if (journey === null) {
    return 'unknown';
  }
  if (journey.isPreview) {
    return 'preview';
  }
  return journey.locked.some((row) => row.key === capability) ? 'locked' : 'open';
};
